var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"button button-primary flex-1",attrs:{"role":"button"},on:{"click":function($event){return _vm.$emit('save')}}},[_vm._v("\n    "+_vm._s(_vm.confirmButtonText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }